import achievements from '../../data/achievements'
import Achievement from '../../models/Achievement'



// initial state
const state = () => ({

})

// getters
const getters = {
    stats: () => {
        const achievements = Achievement.all()
        const stats = {}
        stats.total = achievements.length
        stats.completed = achievements.filter((achievement) => achievement.completed).length
        stats.progress = Math.round(stats.completed / stats.total * 100)
        return stats
    },
    filtered: (state, getters, rootState) => {
        switch(rootState.configurations.filter) {
          case "completed":
            return Achievement.query().where('completed', true).get()
          case "uncompleted":
            return Achievement.query().where('completed', false).get()
          default:
            return Achievement.query().all();
        }
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', achievements)
    },
    complete({ commit }, achievement) {
        commit('complete', { achievement })
    },
    uncomplete({ commit }, achievement) {
        commit('uncomplete', { achievement })
    }
}

// mutations
const mutations = {
    load(state, achievements) {
        // Restore completed achievements
        achievements.forEach(achievement => {
            if (Achievement.query().where((persistedAchievement) => { return persistedAchievement.completed && persistedAchievement.id == achievement.id }).exists()) {
                achievement.completed = true
            }
        });
        Achievement.create({
            data: achievements
        })
    },
    complete(state, { achievement }) {
        Achievement.update({
            where: achievement.id,
            data: {
                completed: true
            }
        })
    },
    uncomplete(state, { achievement }) {
        Achievement.update({
            where: achievement.id,
            data: {
                completed: false
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}